import GenerateHelp from './GenerateHelp'

export default GenerateHelp
